import { ScoreFactor } from "@inrange/building-manager-api-client/models-site";
import { Modal, ModalView } from "@inrange/theme-components";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { STATUS_COLOR, STATUS_SYMBOL } from "../../utils/scoreFactorStyles";

type SiteScoreSuggestionModalProps = {
  currentScore: number | null | undefined;
  suggestedScore: number;
  factors: ScoreFactor[];
  onKeepCurrent: () => void;
  onAcceptSuggested: () => void;
};

const SiteScoreSuggestionModal = ({
  currentScore,
  suggestedScore,
  factors,
  onKeepCurrent,
  onAcceptSuggested,
}: SiteScoreSuggestionModalProps) => {
  const currentLabel =
    currentScore === null || currentScore === undefined
      ? "no score"
      : `${currentScore}`;
  return (
    <Modal>
      <ModalView
        id="update-site-score-modal"
        title={<>Update site score?</>}
        titlePadding="0"
        fontWeight="500"
        fontSize="18px"
        centerTitle={true}
        width="500px"
      >
        <p style={{ marginTop: "10px", marginBottom: "8px" }}>
          Based on the factors below, the suggested score for this site is{" "}
          <strong>{suggestedScore}</strong> (currently {currentLabel}).
        </p>
        <Table
          striped
          bordered
          style={{ fontSize: "14px", marginTop: "10px" }}
        >
          <thead>
            <tr>
              <th>Factor</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {factors.map((f) => (
              <tr key={f.key}>
                <td style={{ whiteSpace: "nowrap" }}>
                  <span
                    style={{
                      color: STATUS_COLOR[f.status],
                      fontWeight: 600,
                      marginRight: "6px",
                    }}
                  >
                    {STATUS_SYMBOL[f.status]}
                  </span>
                  {f.label}
                </td>
                <td>{f.message}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <Button variant="secondary" onClick={onKeepCurrent}>
            Keep current score
          </Button>
          <Button variant="success" onClick={onAcceptSuggested}>
            Update to suggested
          </Button>
        </div>
      </ModalView>
    </Modal>
  );
};

export default SiteScoreSuggestionModal;
